import { UniversalFinalizationRegistry } from "./UniversalFinalizationRegistry";
export var observerFinalizationRegistry = new UniversalFinalizationRegistry(function (adm) {
  var _a;
  (_a = adm.reaction) === null || _a === void 0 ? void 0 : _a.dispose();
  adm.reaction = null;
});